import type { quickLoanChannelType } from '@/api/quick-withdraw/types';
import { checkDualChannelLight36 } from '@/api/rights';
import { ubtSendError } from '@/shared/utils/ubt';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { Dialog } from '@hb/coffee';

export const quickWithdrawCardUtils = {
  /** 快速提现流程-右侧轻资产场景-限制版本
   * 需求初始方案：https://hellobike.yuque.com/gpxxgb/oyyz8n/tnivcnbk9nrook6h
   * 需求metis:https://metis2.hellobike.cn/team/detail/issue?filterId=3846&openDetail=667713&teamId=198
   * @return 是否能切换到普通通道
   */
  async getCommonModeRes(channel?: quickLoanChannelType): Promise<boolean> {
    try {
      // 获取当前选中渠道的rightLight36ProductId
      const {
        rightLightUncreditedProduct,
      } = channel || {};
      if (!rightLightUncreditedProduct || !rightLightUncreditedProduct.productId) {
        return true;
      }
      ubtSetupPageButton('finance_loan_right_hasLightProductId', {
        rightLightUncreditedProductId: rightLightUncreditedProduct?.productId,
      });

      // 调用检查切换资产模式接口，传入rightLightUncreditedProductId
      const { checkResult, failReason } = await checkDualChannelLight36({
        uncreditedProductId: rightLightUncreditedProduct?.productId,
      });

      const ubtParams = {
        scene: 'quick_withdraw_card',
        type: 'check_limit',
      };

      if (failReason) {
        ubtSetupModuleExpose('fincance_loan_normalapply_limitPopup_expose', ubtParams);
        // 有失败原因，阻止切换
        Dialog.alert({
          title: '提示',
          // 文案暂时由前端写死
          message: '您申请匹配的机构匹配失败，您可以选择其他机构或稍后再试',
          confirmButtonText: '我知道了',
          closeable: false,
        }).then(() => {
          ubtSetupPageButton('fincance_loan_normalapply_limitPopup_click', ubtParams);
          // 有失败
        });

        return false;
      }

      // 埋点上报接口调用结果
      ubtSetupPageButton('finance_loan_right_checkLightSuccess', {
        result: checkResult,
      });

      return true;
    } catch (error) {
      // 错误处理和上报，但不向外抛错，静默处理
      ubtSendError({
        name: 'finance_check_dual_channel_light36_error',
        message: error instanceof Error ? error.message : 'Unknown error',
      });

      // 静默处理，返回true，不影响用户其他操作
      return true;
    }
  },
};
